import {
  bool, func, shape, string,
} from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { View } from 'react-native';

import { FORMS, STYLE } from 'common';
import { Consumer } from 'context';
import {
  Button, Dialog, fetch, Form,
} from 'reactor/components';
import { THEME } from 'reactor/common';

const { STORY_PAGE } = FORMS;
const { COLOR } = THEME;
const DEFAULT_TYPE = 'content';

class DialogPage extends PureComponent {
  static propTypes = {
    dataSource: shape({}),
    onClose: func,
    pageId: string,
    visible: bool.isRequired,
  };

  static defaultProps = {
    dataSource: {},
    pageId: undefined,
    onClose: undefined,
  };

  constructor(props) {
    super(props);
    this.state = { busy: false, dataSource: props.dataSource, valid: false };
  }

  componentWillReceiveProps({ dataSource }) {
    this.setState({ busy: false, dataSource, valid: false });
  }

  _onFormChange = dataSource => this.setState({ dataSource })

  _onFormValid = valid => this.setState({ valid })

  _onClone = ({ story, onData }) => {
    const { props: { onClose }, state: { dataSource } } = this;
    const { pages = [] } = story;

    onData('story', { ...story, pages: [...pages, dataSource] });
    onClose();
  }

  _onRemove = ({ story, onData }) => {
    const { props: { onClose }, state: { dataSource } } = this;
    const { pages = [] } = story;

    onData('story', {
      ...story,
      pages: pages.filter(page => page.id !== dataSource.id),
    });
    onClose();
  }

  _onSubmit = async ({ story, onData, onError } = {}) => {
    const { props: { onClose }, state: { dataSource } } = this;
    let { pages = [] } = story;

    this.setState({ busy: true });
    // -------------------------------------------------------------------------
    // @TODO: Use service [POST|UPDATE] ...mapi/story/${story.id}
    // let service = `/story/${story.id}`;
    // if (dataSource.id) service += `/page/${dataSource.id}`;
    await fetch({ endpoint: 'mockbin.org', service: 'request' }).catch(onError);
    if (dataSource.id) {
      pages = pages.map(page => (
        page.id !== dataSource.id ? page : { ...page, ...dataSource }
      ));
    } else {
      pages.push({ ...dataSource, id: (new Date()).getTime().toString() });
    }
    // -------------------------------------------------------------------------
    onData('story', { ...story, pages });
    this.setState({ busy: false });
    onClose();
  }

  render() {
    const {
      _onFormChange, _onFormValid, _onClone, _onRemove, _onSubmit,
      props: { pageId, ...props },
      state: { dataSource = {}, busy, valid },
    } = this;
    const { id, type = DEFAULT_TYPE } = dataSource;
    const isBusy = busy ? { activity: true, disabled: true } : {};

    return (
      <Consumer>
        { ({ l10n = {}, ...context }) => (
          <Dialog {...props} title={`${id ? l10n.EDIT : l10n.NEW} ${l10n.PAGE}`}>
            <Form
              attributes={{ ...STORY_PAGE.DEFAULT, ...(type ? STORY_PAGE[type.toUpperCase()] : {}) }}
              value={dataSource}
              onChange={_onFormChange}
              onValid={_onFormValid}
              style={STYLE.dialogForm}
            />
            <View style={STYLE.actions}>
              { !busy && id && (
                <Fragment>
                  <Button
                    {...isBusy}
                    onPress={() => _onClone(context)}
                    outlined
                    title={l10n.CLONE}
                  />
                  <Button
                    {...isBusy}
                    color={COLOR.ERROR}
                    onPress={() => _onRemove(context)}
                    outlined
                    title={l10n.DELETE}
                  />
                </Fragment>)}
              <View style={STYLE.actionSeparator} />
              <Button
                disabled={!valid}
                {...isBusy}
                onPress={() => _onSubmit(context)}
                primary
                title={id ? l10n.SAVE : l10n.CREATE}
              />
            </View>
          </Dialog>
        )}
      </Consumer>
    );
  }
}

export default DialogPage;
